import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import { Field, FormikProvider, useFormik } from 'formik'
import CustomInput from '../../../components/common/CustomInput'
import * as Yup from 'yup'

const validationSchema = Yup.object({
  name: Yup.string().trim().required('Name is required'),
})

const Add = () => {
  const navigate = useNavigate()
  const [submitted, setSubmitted] = useState(false) 

  const handleSubmit = async (values, { resetForm, setSubmitting }) => {
    if (submitted) return 
    setSubmitted(true) 
    try {
      const response = await axiosAuthInstance.post('role/add', {
        name: values.name,
      })
      if (response) {
          navigate('/roles')
      }
    } catch (error) {
      console.log(error)
    } finally {
      setSubmitting(false) 
    }
  }

  const formik = useFormik({
    onSubmit: handleSubmit,
    validationSchema,
    initialValues: {
      name: '',
    },
  })

  return (
    <FormikProvider value={formik}>
      <form
        className='flex flex-col p-4 gap-4'
        onSubmit={(e) => {
          e.preventDefault()
          formik.handleSubmit()
        }}
      >
        <Field
          name='name'
          label='Name'
          placeholder='Name'
          required
          component={CustomInput}
        />
        <button
          type='submit'
          disabled={submitted || formik.isSubmitting} 
          className='bg-primary text-xl font-medium text-white rounded-lg px-6 py-2'
        >
          {formik.isSubmitting ? (
            <div className='w-5 h-5 mx-auto border-2 border-white border-solid rounded-full loader animate-spin border-t-transparent'></div>
          ) : ('Add')}
        </button>
      </form>
    </FormikProvider>
  )
}

export default Add
